import React, { useState, useEffect } from "react";
import { Box, Grid, Typography, Button } from "@mui/material";

  const handleQuoteClick = () => {
    document.getElementById("contact-form")?.scrollIntoView({ behavior: "smooth" });
  };

const bannerItems = [
    {
        title: 'ENHANCE YOUR GARDEN WITH A LOURVERED PERGOLA',
        subtitle: <Typography variant="h6"></Typography>,
        size: {xs: 12,  md: 6}
    },
    {
        title: 'GET A FREE QUOTATION NOW',
        subtitle: <Button variant="contained" size="small" sx={{ mt: 2, backgroundColor: '#1a1a1a', color: 'white' }} onClick={handleQuoteClick}>GET A QUOTE</Button>,
        size: {xs: 12,  md: 6}
    }
];

export default function QuotationBannerFullWidth() {
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        // Set up an interval to cycle through the items
        const interval = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % bannerItems.length);
        }, 1500); // Change item every 3 seconds

        // Clean up the interval when the component unmounts
        return () => clearInterval(interval);
    }, []); // Empty dependency array ensures this effect runs only once on mount

    return (
        <Box sx={{ backgroundColor: 'rgb(22, 161, 216)', overflow: 'hidden' }}>
            <Box sx={{ display: 'flex', flex: 1, justifyContent: 'center', color: '#FFF' }} p={3}>
                <Grid container sx={{ flex: 1, display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                    {bannerItems.map((bannerItem, index) => (
                        <Grid 
                            item 
                            key={index} 
                            size={bannerItem.size}
                            sx={{
                                display: 'flex',
                                justifyContent: 'center', // Corrected 'centre' to 'center'
                                alignItems: 'center',
                                textAlign: 'center',
                                flexDirection: 'column',
                                padding: 2,
                                // Add transition for a smooth effect
                                transition: 'transform 0.5s ease-in-out, text-shadow 0.5s ease-in-out',
                                // Conditionally apply the "glow" effect
                                transform: activeIndex === index ? 'scale(1.15)' : 'scale(1)',
                                textShadow: activeIndex === index ? '0 0 12px rgba(255, 255, 255, 0.7)' : 'none',
                            }}
                            p={3}
                        >
                            <Typography variant="h4" fontWeight={'bold'}>
                                {bannerItem.title}
                            </Typography>
                            {bannerItem.subtitle}
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
}